// import defaultTheme from 'core/themes/serenity/serenityDefault'
import lightTheme from 'core/themes/serenity/serenityLight'
import { ThemeConfig } from './model'
import { path } from 'ramda'
import Theme from 'core/themes/model'

export const componentUpdaterObject = (themePath, value) => {
  return {
    pathTo: themePath,
    value: value || path(['components', ...themePath], lightTheme),
  }
}

export const generateThemeUpdatePayload = (
  { sidenavColor, sidenavTextColor, sidenavActiveTextColor, sidenavBorderColor }: ThemeConfig,
  theme: Theme,
) => {
  return {
    components: [
      // componentUpdaterObject(['header', 'background'], headerColor),
      componentUpdaterObject(['sidebar', 'background'], sidenavColor),
      componentUpdaterObject(['sidebar', 'text'], sidenavTextColor),
      componentUpdaterObject(['sidebar', 'activeText'], sidenavActiveTextColor),
      componentUpdaterObject(
        ['sidebar', 'activeIcon'],
        // TODO: This is a temporary fix. Expose a theme variable in custom theme to handle this
        // For now, we are using the same color as activeText for custom theme
        // And for default theme, we are using default to themes activeIcon color
        sidenavActiveTextColor === '#3d3d57' //default theme active text color
          ? theme.components.sidebar.activeIcon
          : sidenavActiveTextColor,
      ),
      componentUpdaterObject(['sidebar', 'hoverText'], sidenavActiveTextColor),
      componentUpdaterObject(['sidebar', 'border'], sidenavBorderColor),
    ],
  }
}
